export const TONE_SLIDERS = [
  {
    key: "formality",
    label: "Formality",
    minLabel: "Casual",
    maxLabel: "Formal",
  },
  {
    key: "empathy",
    label: "Empathy",
    minLabel: "Low",
    maxLabel: "High",
  },
  {
    key: "enthusiasm",
    label: "Enthusiasm",
    minLabel: "Reserved",
    maxLabel: "Enthusiastic",
  },
  {
    key: "conciseness",
    label: "Conciseness",
    minLabel: "Detailed",
    maxLabel: "Concise",
  },
  {
    key: "verbosity",
    label: "Verbosity",
    minLabel: "Minimal",
    maxLabel: "Elaborate",
  },
  {
    key: "assertiveness",
    label: "Assertiveness",
    minLabel: "Passive",
    maxLabel: "Assertive",
  },
  {
    key: "technical_depth",
    label: "Technical Depth",
    minLabel: "Non-technical",
    maxLabel: "Highly technical",
  },
  {
    key: "proactiveness",
    label: "Proactiveness",
    minLabel: "Reactive",
    maxLabel: "Proactive",
  },
  {
    key: "confidence_level",
    label: "Confidence Level",
    minLabel: "Cautious",
    maxLabel: "Confident",
  },
];

export const AGENT_TONE_SELECT_OPTIONS = {
  mode: ["balanced", "strict", "creative"],
  personality_type: ["Professional", "Friendly", "Casual", "Formal"],
  brand_voice: ["Neutral", "Friendly", "Authoritative", "Playful", "Custom"],
  communication_style: [
    "Conversational",
    "Instructional",
    "Persuasive",
    "Informative",
  ],
  greeting_style: [
    "Warm & Welcoming",
    "Direct & Brief",
    "Enthusiastic",
    "Neutral",
  ],
  question_asking_style: [
    "Ask clarifying questions first",
    "Answer first, then ask",
    "Avoid questions unless necessary",
  ],
  closing_style: ["Friendly wrap-up", "Action-oriented", "Neutral close"],
  error_handling_style: [
    "Apologetic",
    "Neutral & factual",
    "Reassuring & solution-focused",
  ],
  apology_level: ["None", "Minimal", "Moderate"],
  hedging_level: [
    "Low (direct statements)",
    "Medium (balanced)",
    "High (cautious language)",
  ],
  instruction_vs_explanation_preference: [
    "Mostly instructions",
    "Balanced",
    "Mostly explanations",
  ],
  user_expertise_level: ["Beginner", "Intermediate", "Expert"],
  industry_domain: [
    "General",
    "Fintech",
    "Healthcare",
    "E-commerce",
    "Developer Tools",
    "Custom",
  ],
  use_case_type: [
    "Customer Support",
    "Sales",
    "Onboarding",
    "Knowledge Base",
    "General Assistant",
  ],
  output_language: ["en", "es", "fr", "de", "ar"],
  localization_region: ["US", "UK", "AU", "CA", "PK"],
  formatting_style: ["Plain text", "Bulleted lists", "Structured sections"],
};

export const AGENT_TONE_TOGGLE_FIELDS = [
  {
    key: "ask_clarifying_questions",
    label: "Ask Clarifying Questions",
    description: "Allow follow-up questions when context is incomplete.",
  },
  {
    key: "suggest_next_steps",
    label: "Suggest Next Steps",
    description: "Close with actionable next-step guidance.",
  },
  {
    key: "provide_examples",
    label: "Provide Examples",
    description: "Include concrete examples where helpful.",
  },
  {
    key: "summarize_at_end",
    label: "Summarize at End",
    description: "Add concise recap after the response.",
  },
  {
    key: "use_bullets_when_appropriate",
    label: "Use Bullets When Appropriate",
    description: "Prefer bullet lists for scannable output.",
  },
];

export const AGENT_TONE_DEFAULT_STATE = {
  request_id: "demo-123",
  mode: "balanced",
  tone: {
    formality: 70,
    empathy: 80,
    enthusiasm: 60,
    conciseness: 55,
    verbosity: 40,
    assertiveness: 50,
    technical_depth: 65,
    proactiveness: 55,
    confidence_level: 45,
  },
  personality_type: "Professional",
  brand_voice: "Authoritative",
  communication_style: "Instructional",
  greeting_style: "Warm & Welcoming",
  question_asking_style: "Answer first, then ask",
  closing_style: "Action-oriented",
  error_handling_style: "Reassuring & solution-focused",
  apology_level: "Minimal",
  hedging_level: "Medium (balanced)",
  instruction_vs_explanation_preference: "Balanced",
  user_expertise_level: "Intermediate",
  industry_domain: "Developer Tools",
  use_case_type: "Onboarding",
  toggles: {
    ask_clarifying_questions: true,
    suggest_next_steps: true,
    provide_examples: true,
    summarize_at_end: true,
    use_bullets_when_appropriate: true,
  },
  output: {
    output_language: "en",
    localization_region: "US",
    formatting_style: "Structured sections",
  },
  custom_instructions:
    "Keep the response under 3 sentences unless the user asks for more detail.",
};
